import React from "react";
import { Map, Placemark, YMaps } from "@pbe/react-yandex-maps";
import "../SimpleYandexMap/SimpleYandexMap.scss";

type ReactYandexMapProps = {
  coordinates?: string | null;
  title?: string;
};

const parsePackedCoordinate = (valueStr: string, dir: string): number | null => {
  if (!valueStr) return null;

  const cleanValue = valueStr.replace(/[^\d]/g, "");
  const degreeDigits = dir === "N" || dir === "S" ? 2 : 3;

  if (cleanValue.length <= degreeDigits) return null;

  const degrees = parseInt(cleanValue.slice(0, degreeDigits), 10);
  const minutesRaw = cleanValue.slice(degreeDigits);
  const minutes = parseInt(minutesRaw, 10) / 100;

  if (Number.isNaN(degrees) || Number.isNaN(minutes)) return null;

  let decimal = degrees + minutes / 60;

  if (dir === "S" || dir === "W") {
    decimal = -decimal;
  }

  return decimal;
};

const parseCoordinates = (coordinates?: string | null): [number, number] | null => {
  if (!coordinates) return null;

  const match = coordinates.trim().match(/([NSns])\s+([0-9.,]+)\s+([EWew])\s+([0-9.,]+)/);
  if (!match) return null;

  const [, latDirRaw, latStr, lonDirRaw, lonStr] = match;
  const lat = parsePackedCoordinate(latStr, latDirRaw.toUpperCase());
  const lon = parsePackedCoordinate(lonStr, lonDirRaw.toUpperCase());

  if (lat == null || lon == null || Number.isNaN(lat) || Number.isNaN(lon)) {
    return null;
  }

  return [lat, lon];
};

const ReactYandexMap = ({ coordinates, title = "Координаты" }: ReactYandexMapProps) => {
  const parsedCoordinates = parseCoordinates(coordinates);

  if (!coordinates) {
    return (
      <div className="simple-yandex-map__no-coordinates">
        Нет данных о координатах
      </div>
    );
  }

  if (!parsedCoordinates) {
    return (
      <div className="simple-yandex-map">
        <div className="simple-yandex-map__header">
          <div>{title}</div>
        </div>
        <div className="simple-yandex-map__no-coordinates">
          Некорректный формат координат: {coordinates}
        </div>
      </div>
    );
  }

  return (
    <div className="simple-yandex-map">
      <div className="simple-yandex-map__header">
        <div className="coordinates-container">
          <div>
            <div>{title}: {coordinates}</div>
            <div style={{ color: "#666" }}>
              (в десятичном виде: {parsedCoordinates[0].toFixed(6)}°, {parsedCoordinates[1].toFixed(6)}°)
            </div>
          </div>
        </div>
      </div>
      <div className="simple-yandex-map__map-container">
        <YMaps
          query={{
            apikey: "b030dfb7-b5b0-433a-b396-eb046802320b",
            lang: "ru_RU",
            load: "package.full",
            ns: "ymapsReactShared"
          }}
        >
          <Map
            defaultState={{ center: parsedCoordinates, zoom: 15, controls: [] }}
            width="100%"
            height="250px"
          >
            <Placemark
              geometry={parsedCoordinates}
              properties={{
                hintContent: coordinates,
                balloonContent: coordinates
              }}
            />
          </Map>
        </YMaps>
      </div>
    </div>
  );
};

export default ReactYandexMap;
